import Parse from "parse";

type Invoice = Parse.Object;
type OD3_Tenant = Parse.Object;

export interface InvoicePageAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;
  invoice: Invoice;
  title: string;
  description?: string;
  image?: Parse.File;
  draft: boolean;
  deleted: boolean;
  annotations: any[];
  order: number;
  tenant: OD3_Tenant;
  imageWidth?: number;
  imageHeight?: number;
}

export class InvoicePage extends Parse.Object<InvoicePageAttributes> {
  constructor(data?: Partial<InvoicePageAttributes>) {
    super("APP_InvoicePage", data as InvoicePageAttributes);
  }
}

Parse.Object.registerSubclass("APP_InvoicePage", InvoicePage);
